import React from 'react'
import {
  Divider,
  Grid,
} from '@material-ui/core'
import { checkBookmarked, useBookmarkState } from "../Molecules/BookmarkButton"
import { ClauseCard, MainPageContainer, PaginatedResults, Sidebar } from '../Organisms'
import { SearchService } from '../../services'
import { useAsyncError } from '../../utils/Error'
import { useParams } from '../../utils/Hooks'
import { useTranslation } from 'react-i18next'

const SimilarClauses = ({ match: { params: { clauseId } } }) => {
  const { t } = useTranslation()
  const throwError = useAsyncError()
  const [sidebarClause, setSidebarClause] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [similarClausesSearchResult, setSimilarClausesSearchResult] = React.useState(null)
  const [originalClause, setOriginalClause] = React.useState(null)
  const { page, page_size } = useParams()
  const [bookmarks, updateBookmarks] = useBookmarkState("clause")

  const handleClickCard = React.useCallback(clause => setSidebarClause(clause), [])

  React.useEffect(() => {
    setLoading(true)
    let isSubscribed = true

    SearchService.getClauseById(clauseId)
      .then(result => {
        if (isSubscribed) setOriginalClause(result)
      })
      .catch(throwError)

    SearchService.getSimilarClauses(clauseId, page, page_size)
      .then(result => {
        if (isSubscribed) {
          setSimilarClausesSearchResult(result)
          setLoading(false)
        }
      })
      .catch(throwError)

    return () => isSubscribed = false
  }, [clauseId, page, page_size, throwError])

  return (
    <MainPageContainer>
      <Grid container spacing={5} item xs={11}>
        <Grid item xs={8}>
          {originalClause &&
            <React.Fragment>
              <ClauseCard
                style={{ backgroundColor: '#F5F5F5', marginTop: 8, marginBottom: 8 }}
                clause={originalClause}
                handleClickCard={() => handleClickCard(originalClause)}
                isBookmarked={checkBookmarked(originalClause.clause_id, bookmarks)}
                updateBookmarks={updateBookmarks(originalClause.clause_id)}
              />
              <Divider>{t('search.originalClause')}</Divider>
            </React.Fragment>
          }
          <PaginatedResults
            handleClickCard={handleClickCard}
            loading={loading}
            searchResult={similarClausesSearchResult}
            variant='clauses'
          />
        </Grid>
      </Grid>
      <Sidebar
        open={sidebarClause}
        clause={sidebarClause}
        onClose={() => setSidebarClause(null)}
      />
    </MainPageContainer >
  )
}

export default SimilarClauses
